import { memo } from "react";
import Link from "next/link";
import clsx from "clsx";

import s from "./styles.module.css";

interface SectionLinkProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
  className?: string;
}

interface LinkViewProps {
  className?: string;
  children: React.ReactNode;
}

export const LinkView = ({ children, ...props }: LinkViewProps) => (
  <span {...props}>{children}&nbsp;→</span>
);

function SectionLink({
  children,
  className,
  href,
  ...props
}: SectionLinkProps) {
  return (
    <Link href={href || "/"}>
      <LinkView {...props} className={clsx(s.link, className)}>
        {children}
      </LinkView>
    </Link>
  );
}

export default memo(SectionLink);
